import { useEffect, useState } from "react";
import api from "@/lib/api";

export const MODULE_ROUTES = {
  "Estimates & repair orders": "/shop/repair-orders", "Customer management": "/shop/repair-orders", "Contractor Advisor": "/shop/repair-orders", "Tech Advisor": "/shop/time-clock",
  "Inventory management": "/shop/parts", "The Stipulator": "/shop/stipulator", "Dealer Advisor": "/shop/inventory", "Lead Advisor": "/demo/app/leads", "Cow Desk": "/demo/app/calls",
  "Marketing Advisor": "/demo/app/campaigns", "Web Advisor": "/demo/app/audits", "Reporting & analytics": "/demo/app/reports",
};
export const MODULE_BLURB = {
  "Estimates & repair orders": "Build estimates, get customer approval and move jobs through to invoice.", "Customer management": "Vehicle profiles with VIN decoding and customer history.",
  "Contractor Advisor": "Job tickets with labor, parts and sign-off — same engine as repair orders.", "Tech Advisor": "Technician time clock, job timers and productivity.",
  "Inventory management": "Parts on hand, reorder alerts and margins.", "The Stipulator": "Electronic deal jackets, stipulations and e-signatures.", "Dealer Advisor": "Vehicle inventory, CSV imports and listings.",
  "Lead Advisor": "Lead pipeline from new to won.", "Cow Desk": "Call queue with dispositions (calls are simulated in the demo).", "Marketing Advisor": "Promotions and reminder campaigns (nothing is actually sent).",
  "Web Advisor": "Run a real website check on any public site.", "Reporting & analytics": "Shop totals, pipeline and inventory at a glance.",
};

let cache = null;
export const useDemo = (enabled = true) => {
  const [d, setD] = useState(cache);
  useEffect(() => { if (!enabled) return; api.get("/api/demos/me").then(r => { const off = new Date(r.data.server_time) - Date.now(); cache = { ...r.data, offset: off }; setD(cache); }).catch(() => {}); }, [enabled]);
  return d;
};
